package pl.decks.personal.components.widgets.iconribbon

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.graphics.Color

data class IconRibbonOption(
    val title: String,
    val color: Color,
    val icon: @Composable () -> Unit,
)
